import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { chargeSlabQueries } from '@/services/chargeSlab/chargeSlab.queries';

export const useChargeManagementDetail = (chargeCategoryId: string | undefined) => {
  const { data, isLoading } = useQuery({
    ...chargeSlabQueries.detail(chargeCategoryId || ''),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
    enabled: !!chargeCategoryId,
  });

  return { chargeDetail: data?.data ?? null, isLoading };
};
